import type { EntityId, Lead, Stage } from "../../types.ts";

export type LeadStageContextMenuState = {
  lead: Lead;
  x: number;
  y: number;
};

export function LeadStageContextMenu({
  menu,
  stages,
  onMove,
  onClose,
}: {
  menu: LeadStageContextMenuState;
  stages: Stage[];
  onMove: (leadId: EntityId, stageId: string) => void;
  onClose: () => void;
}) {
  const currentStageId = String(menu.lead.stage || "");
  const left = Math.max(8, Math.min(menu.x, window.innerWidth - 260));
  const top = Math.max(8, Math.min(menu.y, window.innerHeight - 340));

  function moveTo(stageId: string) {
    if (stageId === currentStageId) return;
    onMove(menu.lead.id, stageId);
    onClose();
  }

  return (
    <div
      className="lead-stage-context-menu"
      style={{ left, top }}
      role="menu"
      aria-label="Mover lead para etapa"
      onClick={(event) => event.stopPropagation()}
    >
      <div className="lead-stage-context-title">Mover para etapa</div>
      {stages.length ? stages.map((stage) => {
        const isCurrent = stage.id === currentStageId;
        return (
          <button
            key={stage.id}
            className={`lead-stage-context-item ${isCurrent ? "is-current" : ""}`}
            type="button"
            role="menuitem"
            disabled={isCurrent}
            aria-current={isCurrent ? "true" : undefined}
            onClick={() => moveTo(stage.id)}
          >
            <span className="lead-stage-context-dot" style={{ background: stage.color }} />
            <span className="lead-stage-context-name">{stage.title}</span>
            {isCurrent ? <span className="lead-stage-context-current">Atual</span> : null}
          </button>
        );
      }) : (
        <div className="lead-stage-context-empty">Nenhuma etapa neste funil.</div>
      )}
    </div>
  );
}
